// One-off server calls that don't read or write the cache.
import { consumerApi } from "./client";

export function sendCode(
  phoneNumber: string,
  channel?: Parameters<typeof consumerApi.sendCode>[1],
) {
  return consumerApi.sendCode(phoneNumber, channel);
}

export function verifyCode(
  phoneNumber: string,
  verificationCode: string,
  referral?: Parameters<typeof consumerApi.verifyCode>[2],
  consents?: Parameters<typeof consumerApi.verifyCode>[3],
) {
  return consumerApi.verifyCode(
    phoneNumber,
    verificationCode,
    referral,
    consents,
  );
}

export function signUp(details: Parameters<typeof consumerApi.signUp>[0]) {
  return consumerApi.signUp(details);
}

export function exchangeImpersonationCode(code: string) {
  return consumerApi.exchangeImpersonationCode(code);
}

export function createPlaidLinkToken(plaidLinkId?: string) {
  return consumerApi.createPlaidLinkToken(plaidLinkId);
}

// Fire and forget: nothing waits on Link's diagnostics, and the applicant can't
// act on one going missing, so a failed request is not an error worth reporting.
export function logPlaidLinkEvent(
  data: Parameters<typeof consumerApi.logPlaidLinkEvent>[0],
) {
  return consumerApi.logPlaidLinkEvent(data).catch(() => {});
}
